module.exports = __webpack_public_path__ + "static/media/barrio-chino.ebc31634.md";